import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import { Badge } from "@/components/ui/badge"
import { Button } from "@/components/ui/button"
import { ImageIcon } from "lucide-react"
import { Product } from "@/types/product-type"

interface ProductImagesTabProps {
  product: Product
  onEdit: () => void
}

export function ProductImagesTab({ product, onEdit }: ProductImagesTabProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Product Images</CardTitle>
        <CardDescription>Visual assets for this product</CardDescription>
      </CardHeader>
      <CardContent>
        {product.imageUrl ? (
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            <div className="relative">
              <div className="aspect-video rounded-lg overflow-hidden bg-muted">
                <img
                  src={product.imageUrl}
                  alt={`${product.name} image`}
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    e.currentTarget.src = "/images/placeholder-product.jpg"
                  }}
                />
              </div>
              <Badge className="absolute top-2 left-2" variant="secondary">
                Primary
              </Badge>
            </div>
          </div>
        ) : (
          <div className="text-center py-12">
            <ImageIcon className="h-12 w-12 text-muted-foreground mx-auto mb-4" />
            <h3 className="text-lg font-semibold">No images yet</h3>
            <p className="text-muted-foreground mb-4">Add images to showcase your product.</p>
            <Button onClick={onEdit}>Add Images</Button>
          </div>
        )}
      </CardContent>
    </Card>
  )
}
